import React from "react";
import { HomeGridCellTemplate } from "themes/application/home/components";

function HomeGridCell(props) {
    return <HomeGridCellTemplate {...props} />;
}

export default HomeGridCell;
